import { HStack } from '@/components/Atoms/Layout/HStack'
import { Button, Input } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'
import { SearchIcon } from 'lucide-react'

type SearchFieldProps = {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
  className?: string
  placeholder?: string
  onShowResults?: () => void
  onSearch?: (value: string) => void
}

export default function SearchField(props: SearchFieldProps) {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setValue(e.target.value)
  }

  const handleSearchSubmit = () => {
    if (props.onSearch) {
      props.onSearch(props.value)
    } else {
      props.onShowResults?.()
    }
  }

  return (
    <HStack
      className={cn(
        'focus-within:ring-primary rounded-md border shadow-sm focus-within:ring-1',
        props.className,
      )}
    >
      <Input
        placeholder={props?.placeholder}
        value={props.value}
        onChange={(e) => handleSearchChange(e)}
        className="h-[34px] border-none shadow-none focus-visible:ring-0"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearchSubmit()
          }
        }}
      />
      <Button
        onClick={handleSearchSubmit}
        className="mr-1 size-7 flex-none"
        size="icon"
        variant="ghost"
      >
        <SearchIcon className="size-4" />
      </Button>
    </HStack>
  )
}
